
import { InterceptMiddle } from '../../regular';
/**
 * 判断多选题、排序题、矩阵多选题选择个数
 * @param text 
 * @param condition 条件str
 * @param list 试题list
 * @return Boolean
 */
export const Count = (list, condition) => {
    if (!condition) return false
    let result = false
    try {
        let code = InterceptMiddle(condition, ['['], ['==', '>', '>=', '<', '<=', '_', ':'])
        code = code ? code : undefined
        let num = InterceptMiddle(condition, ['==', '>', '>=', '<', '<='], [']'])
        let row = InterceptMiddle(condition, ['_'], ['==', '>', '>=', '<', '<='])
        list.forEach(info => {
            if (code == info.quesCode && info.bindIsShow && info.isShow) {
                switch(info.questionsTypeId) {
                    case '10': // 多选
                        if (info.userAnswerArr.length == num) {
                            result = true
                        }
                        break
                    case '20': // 矩阵多选
                        if (info.userAnswerArr.length > 0 && num == info.userAnswerArr[row - 1].value.split(',').length) {
                            result = true
                        }
                        break
                }
            }
        })
        return result;
    } catch (error) {
        return false
    }
}